import { render } from "./VacantPlaceTable.vue?vue&type=template&id=e4721ade&scoped=true"
import script from "./VacantPlaceTable.vue?vue&type=script&lang=js"
export * from "./VacantPlaceTable.vue?vue&type=script&lang=js"

import "./VacantPlaceTable.vue?vue&type=style&index=0&id=e4721ade&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4721ade"]])

export default __exports__